import React from 'react'

import Page from '../../../components/pdf/Page'

import Devices, { VivoText } from './_shared/sections/Devices'
import Intro from './_shared/sections/Intro'
import { findReplyByQuestionId } from './_helpers/pdfHelpers'
import View from '../../../components/pdf/View'
import { useServiceOrder } from './_load/ServiceOrderLoader'

const PdfDocument = ({ templateId }) => {
  const serviceOrder = useServiceOrder()

  const mainDeviceReply = findReplyByQuestionId(serviceOrder.replies, 598)
  if (!mainDeviceReply) {
    return (
      <Page>
        <View pageBreakAfter>
          <VivoText bold align={'center'}>
            {'É necessário selecionar um aparelho para fazer um comparativo automático.'}
          </VivoText>
        </View>
      </Page>
    )
  }

  return (
    <Page>
      <Intro />
      <Devices templateId={templateId} />
    </Page>
  )
}

export default PdfDocument
